import React from "react";

import { LogoIcon } from "icons";

export interface ILogo {}

const Logo: React.FC<ILogo> = () => <LogoIcon height="36" />;

export default Logo;
